var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisciplina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 849.12 1090.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M818.36,356.83H30.77c-17,0-30.77,14.79-30.77,33s13.77,33,30.77,33H270.93v518c0,16.81,14.79,30.43,33,30.43s33-13.62,33-30.43V773.13H502.2V1058.7c0,17.45,14.8,31.61,33,31.61s33-14.16,33-31.61V422.91H818.36c17,0,30.76-14.8,30.76-33S835.35,356.83,818.36,356.83ZM502.2,707.05H337V422.91H502.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.6,0A151.86,151.86,0,1,0,571.46,151.86,151.86,151.86,0,0,0,419.6,0Zm0,252A100.12,100.12,0,1,1,519.72,151.86,100.12,100.12,0,0,1,419.6,252Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisciplina);
export default __webpack_public_path__ + "static/media/disciplina.13f9d38e3e11a0bf4fe31fcfc06b0f0d.svg";
export { ForwardRef as ReactComponent };